import { render, staticRenderFns } from "./AutoSuggest.vue?vue&type=template&id=d8c0fbbe"
import script from "./AutoSuggest.vue?vue&type=script&lang=js"
export * from "./AutoSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c0fbbe')) {
      api.createRecord('d8c0fbbe', component.options)
    } else {
      api.reload('d8c0fbbe', component.options)
    }
    module.hot.accept("./AutoSuggest.vue?vue&type=template&id=d8c0fbbe", function () {
      api.rerender('d8c0fbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AutoSuggest.vue"
export default component.exports